module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Pixels-31f02d4155c4849aed6d9a4b7c0dc369.svg";